/**
 * Vehicle detail route helpers — slug/ID resolution (Milestone 7 / M14 SEO).
 *
 * In-app route: /v/:slug/[:locale]/vehicles/:vehicleListingId
 * Public SEO canonical: /carros/:listingSlug (meta tags, external share only)
 */
import { runtimeVehicleDetailPath } from "../../clientViewRuntime/utils/routes";
import { getPublicVehicleDetailPath } from "../../seo/canonicalUrls";

export function resolveListingSlugParam(param) {
  if (param == null || param === "") return null;
  return String(param).trim();
}

export function isCanonicalListingSlug(listing, slugParam) {
  if (!listing || !slugParam) return false;
  const param = String(slugParam).trim().toLowerCase();
  const canonical = String(listing.slug || "").trim().toLowerCase();
  const id = String(listing.id || "").trim().toLowerCase();
  return (canonical && canonical === param) || (id && id === param);
}

/**
 * Preferred in-app detail href under /v/:slug with optional locale segment.
 */
export function getVehicleDetailHref(listing, slug = "automap", options = {}) {
  const { locale = null, preferPublicCanonical = false } = options;

  if (preferPublicCanonical) {
    const publicPath = getPublicVehicleDetailPath(listing);
    if (publicPath) return publicPath;
  }

  if (!listing) return runtimeVehicleDetailPath(slug, "", locale);
  const segment = listing.slug || listing.id || listing.vehicleListingId;
  if (!segment) return runtimeVehicleDetailPath(slug, "", locale);
  return runtimeVehicleDetailPath(slug, segment, locale);
}

export function listingMatchesDetailParam(listing, param) {
  if (!listing || !param) return false;
  const normalized = String(param).trim();
  return (
    String(listing.id) === normalized ||
    String(listing.vehicleListingId || "") === normalized ||
    (listing.slug && String(listing.slug) === normalized)
  );
}
